import React from 'react';

import {SuccessPopupProps} from './SuccessPopup.type';
import Button from '@components/Button';
import {PRIMARY_MESSAGE, SUCCESS_MESSAGE} from './SuccessPopup.constants';

import cn from './SuccessPopup.module.scss';
import SVGIcons from '@components/SVGIcon';
import {ModalWindow} from '@damascus-components/ModalWindow';
import {Image} from '@components/Image';
import ReactHtmlParser from '@libs/reactHtmlParser';

export function SuccessPopup(props: SuccessPopupProps) {
  return (
    <ModalWindow isOpen={props.isOpen}>
      <div className={cn.successWrapper}>
        <span className={cn.successWrapper__icon}>
          <SVGIcons type='success-tick-icon-svg' />
        </span>
        <div className={cn.successWrapper__details}>
          <span className={cn.successWrapper__details__text}>
            {props.primaryMessage
              ? ReactHtmlParser(props.primaryMessage)
              : PRIMARY_MESSAGE}
          </span>
          <span className={cn.successWrapper__details__message}>
            {props.customMessage
              ? ReactHtmlParser(props.customMessage)
              : SUCCESS_MESSAGE}
          </span>
        </div>
        {props.qrImage && (
          <div className={cn.successWrapper__qrImageWrapper}>
            <Image
              url={props.qrImage.url}
              alt={props.qrImage.alt}
              height={150}
              width={150}
            />
          </div>
        )}
        {props.secondaryMessage && (
          <span className={cn.secondaryMessage}>{props.secondaryMessage}</span>
        )}
        <Button onClick={props.onOk}>Ok</Button>
      </div>
    </ModalWindow>
  );
}
